import { Pipe, PipeTransform } from '@angular/core';
import type { Dayjs } from 'dayjs';
import dayjs from '../utils/configured-dayjs';

export enum DateTimeFormat {
  DATE = 'L',
  DATE_TIME_SHORT = 'L LT',
  DATE_TIME_LONG = 'L LTS',
}

@Pipe({ name: 'dateTime' })
export class DateTimePipe implements PipeTransform {
  transform(
    value?: Dayjs | Date | number | string,
    format: DateTimeFormat = DateTimeFormat.DATE_TIME_SHORT,
  ): string {
    let date: Dayjs | undefined;
    if (typeof value === 'number' && value < 10000000000) {
      date = dayjs(value * 1000);
    } else if (typeof value === 'string' && /^\d+$/.test(value)) {
      date = dayjs(Number.parseInt(value, 10));
    } else if (value) {
      date = dayjs(value);
    }
    return date?.locale(dayjs.locale()).format(format) || '';
  }
}
